/**
* @Description 文件功能说明：用户组件
* @Author
* @Time 2021/6/4
**/
<template>
	<div class="view-tree-table">
		<!-- router-title-box start -->
		<div class="router-title-box" >
			<div class="router-title-item">
				<a href="javascript:void(0);" class="router-title-back cursor-pointer" @click="closeRouter" title="返回首页"></a>
				<div class="router-title-tit">
					<span style="position: absolute;">&gt;&ensp;信息采集&ensp;&gt;&ensp;人员信息采集</span>
				</div>
			</div>
		</div>
		<!-- router-title-box end -->
		<UserGroupTree :userGroups="userGroups" :userTypes="userTypes" :showBoxFlag="showTreeBoxFlag" @toggleBox="toggleTreeBox" @setSelectVal="setSelectVal" @setTotal="setTotal" @flushGroup="flushGroup"/>
		<UserTable :userGroups="userGroups" :showBoxFlag="showTreeBoxFlag" ref="userTable"/>
	</div>
</template>

<script>
import GlobalFun from '@/global/global-function'
import UserGroupTree from "@/components_pages/User/UserGroupTree";
import UserTable from "@/components_pages/User/UserTable"
import ApiUser from "@/request/api-user";

export default {
    /*
     * 组件名
     */
    name: "User",
    /**
     * 引用组件
     * */
    components: {
        UserGroupTree,
        UserTable
    },
    /**
     * 数据定义
     * */
    data(){
        return {
            // mini max tree box
            showTreeBoxFlag: true,
            userGroups: [],
            userTypes:[]
        }
    },
    /**
     * 方法定义
     */
    methods:{
        /**
         * @Des 关闭路由
         * @Auth
         * @Date
         */
        closeRouter () {
          // 跳转到 首页
          this.$router.replace({path: this.$store.state.homePage}, ()=>{}, ()=>{});
        },// closeRouter
		
        // 查询用户组
        searchUserGroup() {
            this.$request.postJsonRequest(ApiUser.searchUserGroupApi,{
                // projectId: this.$store.state.currentProjectId
            }).then(result => {
                this.userGroups = [];
                this.userTypes = [];
                if(result.code == 0){
                  /*result.data.forEach((row, index) => {
                    if(row.type == 1){
                      this.userTypes.push(row);
                    }
                  })*/
                  this.userGroups = GlobalFun.dataToTree(Object.assign([], result.data), {
                      id: 'groupId',
                      name: 'groupName',
                      pid: 'parentId',
                      children: 'children',
                      label: 'groupName',
                  });
                }
            }).catch(error => {
                console.error('查询用户组异常', ApiUser.searchUserGroupApi, error);
            })
        },
        // 设置选中的值
        setSelectVal(val){
            if(val){
                this.$refs['userTable'].setSelectVal(val);
            }else{
                this.$refs['userTable'].setSelectVal();
            }
        },
        // 切换 tree box 状态
        toggleTreeBox(val) {
            this.showTreeBoxFlag = val;
        },
        flushGroup(groupId, groupName){
            this.searchUserGroup();
            if(groupId != '' && groupName != ''){
                this.setSelectVal({
                    id: groupId,
                    label: groupName
                })
            }
        },
        setTotal(){
            this.$refs.userTable.searchUsers();
        },
        
    },// methods
    /**
     * 初始化加载
     */
    mounted() {
        // 查询用户组
        this.searchUserGroup();
    },
}

</script>

/* CSS */
<style lang="scss" scoped>
	
</style>



// WEBPACK FOOTER //
// src/views/system-manager/user/User.vue